<a class="col-xs-1-2 _3NMIt9" href="/shop/1396470/search?shopCollection=13486346">
  <div class="_25_r8I _1KtTy-">
    <div class="_1GwifK _2GchKS"
      style="background-image: url(&quot;{{model.imageUrl}}&quot;); background-size: contain; background-repeat: no-repeat;">
    </div>
  </div>
  <div class="DcNis4">SKMEI</div>
</a>
